/*    
<summary>
  This functional component "TaxSettingPopupHOC" provides props to the child component.
  1. State "showTaxSettingPopup" that manages the show/hide of pop up
  2. Function "TaxSettingPopupToggleHandler" to toggle the show/hide popup state "showTaxSettingPopup"
  Developer:Ashutosh Modgil, Created Date:28-Aug-2022, Last Updated By: Mohammad Saquib Khan, Updated Date:26-Oct-2022
</summary>
<returns>Returns JSX</returns>
*/

import React, { useState } from "react";

const TaxSettingPopupHOC = (Component: any) =>
  function Comp(props: any) {
    const [showTaxSettingPopup, setShowTaxSettingPopup] =
      useState<boolean>(false);

    const taxSettingToggleHandler = () => {
      setShowTaxSettingPopup(!showTaxSettingPopup);
    };

    return (
      <Component
        showTaxSettingPopup={showTaxSettingPopup}
        taxSettingPopupToggleHandler={taxSettingToggleHandler}
        {...props}
      />
    );
  };

export default TaxSettingPopupHOC;
